import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "minus-thin",
  "use": "minus-thin-usage",
  "viewBox": "0 0 9 1",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 9 1\" id=\"minus-thin\"><defs><path id=\"minus-thin_a\" d=\"M643 297v-1h9v1z\" /></defs><use xlink:href=\"#minus-thin_a\" fill=\"#373f51\" transform=\"translate(-643 -296)\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol